import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs';

import { TellentHttpApiService } from '@core/tellent-http-legacy';
import type { TellentRole } from '@core/tellent-types';

export type TellentRolesResponse = {
  data: {
    kind: string;
    guid: string;
    roles: TellentRole[];
  };
};

@Injectable({ providedIn: 'root' })
export class TellentRolesHttpClient {
  protected readonly httpApi = inject(TellentHttpApiService);

  public fetchCollection(appGUID: string): Observable<TellentRole[]> {
    return this.httpApi
      .get(`/apps/${appGUID}`, null, null)
      .pipe(map((response: TellentRolesResponse) => response.data.roles));
  }
}
